export function hasTaskInput(
  input: Record<string, unknown> | null | undefined,
): input is Record<string, unknown> {
  return input != null && Object.keys(input).length > 0;
}
